import types from "actions/types"

export const loadLayouts = () => ({ type: types.LOAD_LAYOUTS_ATTEMPT })
export const loadLayoutsSuccess = (layouts) => ({ type: types.LOAD_LAYOUTS_SUCCESS, layouts })
export const loadLayoutsFailure = (code, message) => ({ type: types.LOAD_LAYOUTS_FAILURE, code, message})

export const addLayout = (layout) => ({ type: types.SAVE_LAYOUT_ATTEMPT, layout })
export const addLayoutSuccess = (data) => ({ type: types.SAVE_LAYOUT_SUCCESS, data })
export const addLayoutFailure = (code, message) => ({ type: types.SAVE_LAYOUT_FAILURE, code, message})

export const updateLayout = (layout, id) => ({ type: types.UPDATE_LAYOUT_ATTEMPT, layout, id })
export const updateLayoutSuccess = (data) => ({ type: types.UPDATE_LAYOUT_SUCCESS, data })
export const updateLayoutFailure = (code, message) => ({ type: types.UPDATE_LAYOUT_FAILURE, code, message})

export const deleteLayout = (id, dataSource, isPrivate) => ({ type: types.DELETE_LAYOUT_ATTEMPT, id, dataSource, isPrivate })
export const deleteLayoutSuccess = (data) => ({ type: types.DELETE_LAYOUT_SUCCESS, data })
export const deleteLayoutFailure = (code, message) => ({ type: types.DELETE_LAYOUT_FAILURE, code, message})

export const loadLayoutPanel = (index, dataSource, params) => ({ type: types.LOAD_LAYOUT_PANEL_ATTEMPT, index, dataSource, params })
export const loadLayoutPanelSuccess = (index, data) => ({ type: types.LOAD_LAYOUT_PANEL_SUCCESS, index, data })
export const loadLayoutPanelFailure = (index, code, message) => ({ type: types.LOAD_LAYOUT_PANEL_FAILURE, index, code, message })

export const addLayoutPanel = (layoutId, chart) => ({ type: types.LAYOUT_PANEL_ADD_ATTEMPT, layoutId, chart})
export const addLayoutPanelSuccess = (data) => ({ type: types.LAYOUT_PANEL_ADD_SUCCESS, data })
export const addLayoutPanelFailure = (message, code) => ({ type: types.LAYOUT_PANEL_ADD_FAILURE, message, code })

export const updateLayoutPanel = (index, layoutId, chart) => ({ type: types.LAYOUT_PANEL_UPDATE_ATTEMPT, index, layoutId, chart})
export const updateLayoutPanelSuccess = (data) => ({ type: types.LAYOUT_PANEL_UPDATE_SUCCESS, data })
export const updateLayoutPanelFailure = (message, code) => ({ type: types.LAYOUT_PANEL_UPDATE_FAILURE, message, code })
